import Vue from 'vue'
import { MutationTree } from 'vuex'
import { authTypes } from './types'
import { AuthState, AppConfigSettings, UserInfo } from './state';

export const authMutations: MutationTree<AuthState> = {
  [authTypes.mutations.updateAuthState](state: AuthState, status: boolean) {
    Vue.set(state, authTypes.state.isAuthenticated, status);
    state.isAuthenticated = status;
  },
  [authTypes.mutations.updateAppSettings](state: AuthState, settings: AppConfigSettings) {
    Vue.set(state, authTypes.state.appConfigSettings, settings);
    state.appConfigLoaded = true;
  },

  [authTypes.mutations.updateUserInfo](state: AuthState, userInfo: UserInfo) {
    Vue.set(state, authTypes.state.user, userInfo);
  },
};
